import { ReactNode } from "react";

export interface AuthProviderProps {
    children: ReactNode;
}

export interface UserData {
    username: string;
    image: string;
    subscriber?: string;
    progress?: string;
}

export interface CallbackLoginState {
    goBack: boolean;
    origin: string;
    params?: {};
}

export interface AuthContextType {
    userData: UserData;
    phone: string;
    setPhone: React.Dispatch<React.SetStateAction<string>>;
    handleLogin: (newToken: string | null) => void;
    handleLogout: () => boolean;
    setCallbackLogin: React.Dispatch<React.SetStateAction<CallbackLoginState>>;
    setUserData: React.Dispatch<React.SetStateAction<UserData>>;
    callbackLogin: CallbackLoginState;
    token: string;
}

export const initialUserDataState: UserData = {
    username: '',
    image: '',
};